export default "__VITE_ASSET__XUfXyhn9__"